module.exports = __webpack_public_path__ + "img/help-icon.9428438c.svg";